module.exports = __webpack_public_path__ + "img/picture3.a112ab8b.jpg";